import {
  Battery,
  Box,
  Camera,
  Container,
  Headphones,
  Mic,
  Monitor,
  Package,
  Plane,
  Radio,
  Shield,
  Smartphone,
  Trees,
  Truck,
  Video,
  type LucideIcon,
} from "lucide-react";
import {
  getAssetTypeIconKey,
  getAssetTypeLabel,
} from "@/domains/assets/stores/assetTypeLabels";

export const ASSET_ICON_OPTIONS: ReadonlyArray<{ key: string; label: string }> = [
  { key: "camera", label: "Camera" },
  { key: "video", label: "Video" },
  { key: "trees", label: "Mobile tree" },
  { key: "truck", label: "Camcar / truck" },
  { key: "battery", label: "Batterij" },
  { key: "container", label: "Trailer / container" },
  { key: "plane", label: "Drone" },
  { key: "headphones", label: "Bodycam / headset" },
  { key: "mic", label: "Microfoon" },
  { key: "monitor", label: "Monitor" },
  { key: "package", label: "Pakket" },
  { key: "radio", label: "Radio" },
  { key: "shield", label: "Schild" },
  { key: "smartphone", label: "Smartphone" },
];

const ICONS_BY_KEY: Record<string, LucideIcon> = {
  camera: Camera,
  video: Video,
  trees: Trees,
  truck: Truck,
  battery: Battery,
  container: Container,
  plane: Plane,
  headphones: Headphones,
  mic: Mic,
  monitor: Monitor,
  package: Package,
  radio: Radio,
  shield: Shield,
  smartphone: Smartphone,
  box: Box,
};

export function assetTypeLabel(type: string): string {
  return getAssetTypeLabel(type);
}

export function stripAssetTypePrefix(name: string, type: string): string {
  const label = getAssetTypeLabel(type);
  if (name.toLowerCase().startsWith(label.toLowerCase())) {
    return name.slice(label.length).trim();
  }
  return name;
}

export function getIconByKey(iconKey: string): LucideIcon {
  return ICONS_BY_KEY[iconKey] ?? Box;
}

export function AssetTypeIcon({
  type,
  className,
}: {
  type: string;
  className?: string;
}): React.JSX.Element {
  const Icon = getIconByKey(getAssetTypeIconKey(type));
  return <Icon className={className} aria-hidden />;
}
